
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 67 66","fill":"#fff","fill-rule":"evenodd","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('use',{attrs:{"xlink:href":"#git","x":"1","y":"1"}}),_c('symbol',{attrs:{"id":"git","overflow":"visible"}},[_c('path',{attrs:{"d":"M62.795 29.149L34.853 1.207a4.12 4.12 0 00-5.828 0l-5.8 5.8 7.36 7.36a4.848 4.848 0 015.036 1.174 4.9 4.9 0 011.162 5.066l7.094 7.094a4.89 4.89 0 015.066 1.164 4.905 4.905 0 11-8.006 1.602l-6.616-6.616v17.41c.48.238.919.551 1.3.928a4.904 4.904 0 11-6.936 0 4.71 4.71 0 011.606-1.07V23.547a4.87 4.87 0 01-1.606-1.07 4.9 4.9 0 01-1.056-5.362l-7.26-7.256-19.16 19.14A4.12 4.12 0 000 31.914a4.12 4.12 0 001.209 2.915l27.944 27.94a4.12 4.12 0 005.828 0l27.814-27.77a4.12 4.12 0 000-5.83","stroke":"none","fill":"#f03c2e","fill-rule":"nonzero"}})])])
          )
        }
      }
    